module.exports = __webpack_public_path__ + "img/status-bad.386526cd.svg";